import React, { useState } from 'react';
import AdminRefundsHeader from './AdminRefundsHeader';
import AdminRefundsFilter from './AdminRefundsFilter';
import RefundsListHeader from './RefundsListHeader';
import AdminRefundsList from './AdminRefundsList';

/**
 * 어드민 Refunds & Cancellations.
 * 유저 환불 요청(REQUESTED)을 승인(환불 완료 처리)하거나 거절(예약 복구)하고,
 * 결제 전 취소·환불 완료·거절 이력을 한 곳에서 본다.
 */
const AdminRefunds = () => {
  const [currentFilter, setCurrentFilter] = useState('ALL');

  return (
    <div className='flex flex-col min-w-0 w-full items-start'>
      <AdminRefundsHeader />
      <div className='w-full pb-4 tabletV:pb-6'>
        <AdminRefundsFilter
          currentFilter={currentFilter}
          onFilterChange={setCurrentFilter}
        />
      </div>
      <RefundsListHeader />
      <AdminRefundsList currentFilter={currentFilter} />
    </div>
  );
};

export default AdminRefunds;
